module.exports = __webpack_public_path__ + "img/business_receive_04.9c4cbcde.png";